import React from "react";
import styled from "styled-components";
import { Button } from "../../components/AuthComponents";
import renderIf from "render-if";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
// timeslots component
import TimeslotsComponent from "../../components/TimeslotsComponent/index";

const MainDiv = styled.div`
  width: 90%;
  margin: 1em;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
`;

const BookButton = styled(Button)`
  width: 75%;
`;

const NoServicesDiv = styled.div`
  height: 30vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "75%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "1.5em",
    minWidth: "75%",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
}));

const BookingsInput = ({
  salonId,
  newDate,
  handleChange,
  service,
  services,
  handleSubmit,
  goBack,
  randomValue,
  timeslot,
}) => {
  const classes = useStyles();
  return (
    <MainDiv>
      {renderIf(services.length === 0)(
        <NoServicesDiv>
          <p>This HairQ Point has no services available at the moment</p>
          <BookButton onClick={goBack}>Go Back</BookButton>
        </NoServicesDiv>
      )}

      {renderIf(services.length !== 0)(
        <>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label">
              Select Service
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={service}
              onChange={handleChange}
              label="Select Service"
              name="service"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {services.map((item) => (
                <MenuItem value={item.id} key={randomValue(1, 100)}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <form className={classes.container} noValidate>
            <TextField
              id="date"
              label="Select Appointment Day"
              type="date"
              name="date"
              value={newDate}
              onChange={handleChange}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </form>
          <TimeslotsComponent
            salonID={salonId}
            selectedDate={newDate}
            handleChange={handleChange}
          />
          <BookButton onClick={handleSubmit}>Book</BookButton>
          <h5
            onClick={goBack}
            style={{
              cursor: "pointer",
              borderBottom: "0.5px solid black",
            }}
          >
            Go Back
          </h5>
        </>
      )}
    </MainDiv>
  );
};

export default BookingsInput;
